import React, { useEffect } from 'react';
import ReachBadge from '/fallbacks/reach.svg';
import HTMLReactParser from 'html-react-parser';

const withReach = ({ type, environment, text }) => {
	useEffect(() => {
		const links = document.getElementsByClassName('reach--inline-link');
		links &&
			Array.from(links).forEach((item) => {
				return item.setAttribute('href', '/legal/reach');
			});
	});
	switch (environment) {
		case 'global':
			return (
				<section className="withReach withReach--global">
					<div className="withReach__wrapper">
						{ReachBadge && (
							<img
								className="withReach__icon"
								src={ReachBadge}
								alt={`${general_settings.brand_name} Reach Verified`}
							/>
						)}
						<div className="withReach__seperator"></div>
						<article className="withReach__text">{text && HTMLReactParser(text)}</article>
					</div>
				</section>
			);
		default:
			return (
				<section
					className={`${type == 'accordion' ? 'withReach--accordion' : 'withReach--classic'} withReach`}
					style={environment == 'local' && type != 'accordion' ? { marginBottom: '16px' } : {}}
				>
					<div className="withReach__wrapper">
						<img
							className="withReach__icon"
							src={ReachBadge}
							alt={`${general_settings.brand_name} Reach Verified`}
						/>
						<div className="withReach__seperator"></div>
						<article className="withReach__text">{text && HTMLReactParser(text)}</article>
					</div>
				</section>
			);
	}
};

export default withReach;
